@import '../styles/palette.scss';

.buttonContainer {
  display: flex;
  padding-top: 16px;

  button {
    margin-top: 5px;
  }
}

.right {
  float: right;
}

.fakeDate {
  margin-top: 12px;
}
